import { MaterialCommunityIcons } from "@expo/vector-icons";
import { Button, HStack, Icon, Pressable, Text, VStack } from "native-base";
import React from "react";

import { Address } from "@/interfaces/domain/Address";

type AddressListItemProps = {
  active: boolean;
  address: Address;
  onPress: () => void;
  onPressAddressInfo: () => void;
};

const AddressListItem = ({
  active,
  address,
  onPress,
  onPressAddressInfo,
}: AddressListItemProps) => {
  return (
    <Pressable onPress={onPress}>
      <HStack
        justifyContent="space-between"
        alignItems="center"
        p="2"
        mx="1"
        my="2"
        space="2"
        shadow="4"
        borderRadius="lg"
        bgColor="white.50"
        borderWidth={1}
        borderColor={active ? "primary.600" : "white.50"}>
        <Icon as={<MaterialCommunityIcons name="map-marker" />} size="lg" color="primary.600" />
        <VStack maxW="70%" flexGrow={1}>
          <Text fontSize="md" bold isTruncated>{`${address.rua}, ${address.numero}`}</Text>
          <Text fontSize="md" isTruncated>
            Complemento: {address.complemento}
          </Text>
          <Text fontSize="md" isTruncated>{`${address.cidade}, ${address.estado}`}</Text>
        </VStack>
        <Button variant="ghost" onPress={onPressAddressInfo}>
          <Icon
            as={<MaterialCommunityIcons name="dots-vertical" />}
            size="xl"
            color="primary.600"
          />
        </Button>
      </HStack>
    </Pressable>
  );
};

export default AddressListItem;
